// @ts-nocheck
import * as React from "react";

const CloseCircleLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2l.28.004C17.673 2.152 22 6.57 22 12l-.004.28C21.848 17.673 17.43 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2zm0 2a8 8 0 100 16l.25-.004A8 8 0 0020 12l-.004-.25A8 8 0 0012 4zm1.296 5.284a1 1 0 011.414.006l.006.006a1 1 0 01-.006 1.414L13.41 12l1.3 1.29a1.002 1.002 0 010 1.42l-.003.003a1 1 0 01-1.417-.003L12 13.41l-1.29 1.3a1.002 1.002 0 01-1.42 0l-.003-.003a1 1 0 01.003-1.417l1.3-1.29-1.3-1.29-.084-.095A1.004 1.004 0 0110.71 9.29l1.29 1.3 1.29-1.3.006-.006z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CloseCircleLine);
